var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "progress-input",
    class: {
      error: !_vm.isValid
    },
    on: {
      "click": function ($event) {
        return _vm.$refs['textInput'].focus();
      }
    }
  }, [_c('input', {
    ref: "textInput",
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.handleInput
    }
  }), _c('span', {
    staticClass: "placeholder",
    class: {
      active: _vm.value
    }
  }, [_vm._v(_vm._s(_vm.placeholder))]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isValid,
      expression: "!isValid"
    }],
    staticClass: "noti"
  }, [_vm._v(_vm._s(_vm.validText))])]);
}
var staticRenderFns = []

export { render, staticRenderFns }